import script from "./instructor-change-password.vue?vue&type=script&setup=true&lang=js"
export * from "./instructor-change-password.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__